import { InvoiceTaxModel } from './invoicetax.model';
import { AccountModel } from './account.model';

export class AccountsAndTaxesModel {

  taxes: InvoiceTaxModel[];
  accounts: AccountModel[];

  constructor() { }
}
